import { render, staticRenderFns } from "./Home8.vue?vue&type=template&id=38ae50f1&"
import script from "./Home8.vue?vue&type=script&lang=js&"
export * from "./Home8.vue?vue&type=script&lang=js&"
import style0 from "./Home8.vue?vue&type=style&index=0&id=38ae50f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports